import permission from './permission'
import defaultAvatar from './defaultAvatar'
// 全局注册自定义指令
const install = function(Vue) {
    Vue.directive('permission', permission)
    Vue.directive('defaultAvatar', defaultAvatar)
}

if (window.Vue) {
    window['permission'] = permission
    Vue.use(install); // eslint-disable-line
}

permission.install = install
export default permission


// WEBPACK FOOTER //
// ./src/directive/permission/index.js